import React, { useState } from 'react';
// import MainLayout from '../../components/layout/MainLayout';
import GoalTracking from './GoalTracking';
import { Button } from "@/components/ui/button";
import { Plus } from 'lucide-react';
import { usePermission } from '@/contexts/RoleAccessContext';
import { createCanHelpers } from '@/utils/rbac';
import { useTeamScope } from '@/contexts/TeamScopeContext';

const GoalsPage = () => {
  const { can } = usePermission();
    const { canCreate } = createCanHelpers(can);
    const canCreateGoal = canCreate("goals_okrs");
  const [isCreateGoalOpen, setIsCreateGoalOpen] = useState(false);
  const teamScope = useTeamScope();

  return (
    <>
      <div className="mb-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground" data-testid="goals-heading">{teamScope ? "Team goals" : "Goals & OKRs"}</h1>
          <p className="text-muted-foreground mt-1">
            {teamScope
              ? "Set and track goals for the people who report to you."
              : "Track and manage employee goals, key results, and milestones."}
          </p>
        </div>
        <Button className="bg-primary hover:bg-primary/90 gap-2" 
        onClick={() => setIsCreateGoalOpen(true)} 
        data-testid="create-goal-btn"
        disabled={!canCreateGoal}
        >
          <Plus className="h-4 w-4" /> New Goal
        </Button>
      </div>
      <GoalTracking isCreateOpen={isCreateGoalOpen} onOpenChange={setIsCreateGoalOpen} />
    </>
  );
};

export default GoalsPage;
